import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const CommuteBoat = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M22 19C22 19.552 21.552 20 21 20C20.448 20 20 19.552 20 19C20 18.448 20.448 18 21 18C21.552 18 22 18.448 22 19Z" />
		<path d="M30 15C30 14.448 29.552 14 29 14H25.625L21.125 8C20.186 6.748 18.69 6 17.125 6H9C8.448 6 8 6.448 8 7V10H7C6.448 10 6 10.448 6 11V14H5C4.448 14 4 14.448 4 15V18H3C2.448 18 2 18.448 2 19V23C2 24.654 3.346 26 5 26H21.868C22.916 26 23.901 25.442 24.441 24.544L29.858 15.514C29.948 15.364 30.001 15.189 30.001 15H30ZM6 16H11C11.552 16 12 15.552 12 15C12 14.448 11.552 14 11 14H8V12H13C13.552 12 14 11.552 14 11C14 10.448 13.552 10 13 10H10V8H17.125C18.064 8 18.961 8.449 19.525 9.2L23.125 14H16.236C15.092 14 14.064 14.636 13.553 15.658L12.659 17.447C12.488 17.788 12.146 18 11.764 18H6V16V16ZM22.725 23.514C22.545 23.813 22.217 24 21.867 24H4.999C4.448 24 3.999 23.551 3.999 23V20H11.763C12.907 20 13.935 19.364 14.446 18.342L15.34 16.553C15.511 16.212 15.853 16 16.235 16H27.233L22.724 23.515L22.725 23.514Z" />
	</svg>
);

export default CommuteBoat;
